import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'qaroni-load-button-spinner',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  templateUrl: './load-button-spinner.component.html',
  styleUrl: './load-button-spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadButtonSpinnerComponent {}
